import * as tslib_1 from "tslib";
import openApp from '@ivy/fts/openApp';
import { Component, Vue } from 'vue-property-decorator';
let FixedTop = class FixedTop extends Vue {
    appDown(e) {
        return openApp();
    }
};
FixedTop = tslib_1.__decorate([
    Component
], FixedTop);
export default FixedTop;
